import styled from 'styled-components';
import { Button } from 'reactstrap';

export const SubmitButton = styled(Button)`
  width: 100%;
  height: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: relative;
  background-color: #344792;
  color: #fff;
  :hover {
    background-color: #2c3e50;
  }

  .spinner-border {
    width: 1.5rem;
    height: 1.5rem;
    position: absolute;
  }
`;
